import api from './api';
import { SupportingDocument } from '../types';

export interface CreateSupportingDocumentDto {
  description?: string;
}

/**
 * Map the backend SupportingDocumentResponse shape to the frontend
 * SupportingDocument interface (memberId → userId, created → createdAt, etc.).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapDocument(raw: any): SupportingDocument {
  return {
    id: raw.id,
    invoiceId: raw.invoiceId,
    userId: raw.userId ?? raw.memberId,
    memberName: raw.memberName,
    fileName: raw.fileName,
    fileUrl: raw.fileUrl,
    filePath: raw.filePath,
    mimeType: raw.mimeType,
    fileSize: raw.fileSize,
    description: raw.description,
    createdAt: new Date(raw.createdAt ?? raw.created),
    updatedAt: new Date(raw.updatedAt ?? raw.updated),
  };
}

class SupportingDocumentService {
  private baseUrl = '/invoices';

  async getAll(invoiceId: string): Promise<SupportingDocument[]> {
    const response = await api.get<unknown[]>(
      `${this.baseUrl}/${invoiceId}/supporting-documents`
    );
    return response.data.map(mapDocument);
  }

  async upload(
    invoiceId: string,
    file: File,
    description?: string
  ): Promise<SupportingDocument> {
    const formData = new FormData();
    formData.append('file', file);
    if (description) {
      formData.append('description', description);
    }

    const response = await api.post(
      `${this.baseUrl}/${invoiceId}/supporting-documents`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return mapDocument(response.data);
  }

  async delete(invoiceId: string, documentId: string): Promise<void> {
    await api.delete(
      `${this.baseUrl}/${invoiceId}/supporting-documents/${documentId}`
    );
  }
}

export const supportingDocumentService = new SupportingDocumentService();
